import { AfterViewInit, Component, ViewChild, ElementRef } from "@angular/core";
import { RangeSliderComponent } from "../range-slider/range-slider.component";
import { FiltersService } from "./filters.service";
import { NotificacionesService } from "../../../core/notificaciones/notificaciones.service";
import { Filtro } from '../../../core/modelos/filtro';
import { fuseAnimations } from "../../../core/animations";
import { User } from "../../../core/modelos/user";

@Component({
  selector: "fuse-filters",
  templateUrl: "./filters.component.html",
  styleUrls: ["./filters.component.scss"],
  animations : fuseAnimations
})
export class FiltersComponent implements AfterViewInit {
  filters: Array<Filtro> = [];
  // Display or not the filter
  filtersControl: Map<number, Boolean> = new Map();
  // Store the filter selection
  filtersValues: Map<number, any> = new Map();
  // flag to display more filters
  showMoreFilters: Boolean = false;
  // flag to known if some extrafilter has been set
  isAnyMoreFiltersSet: Boolean = false;
  // filters displayed straight
  filtersShown: Array<Filtro> = [];
  // rest of the filters
  filtersHidden: Array<Filtro> = [];
  // display the mobile filters container
  showMobileFilters: Boolean = false;
  activeMobileView: String = 'map'

  @ViewChild(RangeSliderComponent) rangeSlider: RangeSliderComponent;
  @ViewChild("strInput") strInput: ElementRef;
  @ViewChild("strInputMobile") strInputMobile: ElementRef;
  @ViewChild("filtersContainer") filtersContainer: ElementRef;

  constructor(
    private filtersService: FiltersService, 
    private notificaciones: NotificacionesService
    ) {
    this.getFilters();
  }

  ngAfterViewInit() {
    window.addEventListener('resize', this.getNumberOfVisibleFilters.bind(this));
  }

  toggleFilter(filterId?: number) {
    if (filterId !== undefined) {
      this.showMoreFilters = false;

      setTimeout(() => {
        if (this.strInput) {
          this.strInput.nativeElement.focus()
        }
        if (this.strInputMobile) {
          this.strInputMobile.nativeElement.focus()
        }
      }, 10);
    }

    this.filtersControl.forEach((value, key) => {
      if (filterId === key) {
        this.filtersControl.set(key, !value);
        this.filters[key].isDisplayed = !value;
      } else {
        this.filtersControl.set(key, false);
        this.filters[key].isDisplayed = false;

        if (this.filtersValues.has(key) && !this.filters[key].isSet) {
          this.filtersValues.delete(key);
        }
      }
    });
  }

  toggleMoreFilters() {
    this.showMoreFilters = !this.showMoreFilters;
    this.toggleFilter();

    this.filtersValues.forEach((value, key) => {
      if (key > this.filtersShown.length - 1) {
        this.filtersHidden[key - this.filtersShown.length] = { ...this.filters[key], ...value }
      }
    })
    
  }

  getFilters() {
    
    let params = null
    if (sessionStorage.getItem('usuarioLogueado')){
        const usuario: User = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;

        params = {
          client_id: usuario.cliente.id
        }
    }

    this.filtersService.getFilters(params).subscribe(
      data => {
        this.filters = data;

        for (let index = 0; index < this.filters.length; index++) {
          const element: Filtro = this.filters[index];
          
          let max: number = 0
          let min: number = 0
          if (element.data.length) {
            max = Math.ceil(Math.max.apply(Math, element.data))
            min = Math.floor(Math.min.apply(Math, element.data))

            this.filters[index] = { ...element, ...(!Number.isNaN(max) && { max }), ...(!Number.isNaN(min) && { min }) }
          }

          this.filters[index].isDisplayed = false;
          this.filtersControl.set(element.id, false);
        }

        this.getNumberOfVisibleFilters()
      },
      err => {
        this.notificaciones.errorServidor(err.status);
      }
    );
  }

  getNumberOfVisibleFilters() {
    const inputWidth = 174 + 16 // Computed input width + margin
    const numberOfVisibleFilters = Math.floor(this.filtersContainer.nativeElement.clientWidth / inputWidth) - 2

    this.filtersShown = this.filters.slice(0, numberOfVisibleFilters);
    this.filtersHidden = this.filters.slice(numberOfVisibleFilters);
  }

  setFilter(filterId: number, event: any) {
    if (!this.filtersValues.has(filterId) || JSON.stringify(this.filtersValues.get(filterId)) !== JSON.stringify(event)) {
      this.filtersValues.set(filterId, event);
    }
  }

  saveFilter(filterId: number, stopPropagation?: Boolean) {
    if (this.filtersValues.has(filterId)) {
      this.filters[filterId].isSet = true;
      this.filters[filterId].values = this.humanReadable(this.filtersValues.get(filterId));

      if (this.filters[filterId].hasOwnProperty("units") && this.filters[filterId].units !== undefined) {
        this.filters[filterId].values += ` (${this.filters[filterId].units})`
      }
    }

    if (!stopPropagation) {
      this.toggleFilter(filterId);
    }

    this.publish();
  }

  saveMobileFilter(filterId: number) {
    this.saveFilter(filterId)
    this.displayMobileFilters(false)
  }

  saveFilters(filters: Array<any>) {
    this.isAnyMoreFiltersSet = true;
    filters.forEach(filter => this.saveFilter(filter.id, true));
    this.toggleMoreFilters();
  }

  cancelFilter(filterId: any, stopPropagation?: Boolean): void {
    if (this.filtersValues.has(filterId)) {
      this.filters[filterId].isSet = false;
      this.filters[filterId].values = null;
      this.filtersValues.delete(filterId);
    }

    if (!stopPropagation) {
      this.toggleFilter(filterId);
    }
    
    this.publish();
  }

  cancelFilters(filters: Array<any>) {
    this.isAnyMoreFiltersSet = false;
    filters.forEach(filter => {
      this.cancelFilter(filter.id);
    });
  }

  publish() {
    // Send the signal to another components about the filtering
    const filters = this.filters.reduce((acc, f) => {
      if (this.filtersValues.has(f.id)) {
        acc.push({ key: f.field, value: this.filtersValues.get(f.id) });
      }
      return acc;
    }, []);

    this.filtersService.send(filters);
  }

  onItemListSelection(filterId: number, selectedOptions: any) {
    this.setFilter(filterId, selectedOptions.map((x: any) => x.value));
  }

  isOptionSelected(filterId: number, item: any) {
    return ((this.filtersValues.has(filterId) && this.filtersValues.get(filterId)) || []).includes(item);
  }

  humanReadable(obj: any) {
    if (typeof obj === 'string' || obj instanceof String) {
      return obj.toString()
    }

    if (obj instanceof Array) {
      return obj.join(", ");
    }

    if (obj instanceof Object) {
      const { min, max } = obj;
      return `${min} - ${max}`;
    }
  }

  displayMobileFilters(value) {
    this.showMobileFilters = !!value
  }

  activateFirstFilter() {
    this.displayMobileFilters(true)
    this.toggleFilter(this.filters[0].id)
  }

  activateMobileView(value){
    this.activeMobileView = value
    this.filtersService.activate(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/filters/filters.component.ts